import React, { FC } from "react";
import cn from "classnames";
import PhoneInput, { PhoneInputProps } from "react-phone-input-2";
import "./Phone.flags.scss";
import "./Phone.scss";
import inputStl from "./Input.module.scss";

const Phone: FC<PhoneInputProps> = ({ containerClass, ...props }) => {
  return (
    <PhoneInput
      {...props}
      containerClass={cn(containerClass, inputStl.block)}
    />
  );
};

export default Phone;
